import React from 'react';
import propTypes2 from 'prop-types';
import ReactDOMServer from 'react-dom/server';

export class InfoWindow extends React.Component {
    componentDidMount() {
        this.renderInfoWindow();
    }

    componentDidUpdate(prevProps) {
        const { google, map } = this.props;

        if (!google || !map) {
            return;
        }

        if (map !== prevProps.map) {
            this.renderInfoWindow();
        }

        if (this.props.position !== prevProps.position) {
            this.updatePosition();
        }

        if (this.props.children !== prevProps.children) {
            this.updateContent();
        }

        if ((this.props.visible !== prevProps.visible) || (this.props.marker !== prevProps.marker) || (this.props.position !== prevProps.position) || this.props.children !== prevProps.children) {
            this.props.visible ? this.openWindow() : this.closeWindow();
        }
    }

    componentWillUnmount() {
        this.closeWindow();
    }

    renderInfoWindow() {
        const {
            map,
            google,
            mapCenter,
            ...props
        } = this.props;

        if (!google || !google.maps) {
            return;
        }

        const iw = this.infowindow = new google.maps.InfoWindow({
            content: '',
            ...props,
        });

        google.maps.event.addListener(iw, 'closeclick', this.onClose.bind(this));
        google.maps.event.addListener(iw, 'domready', this.onOpen.bind(this));

        if (this.props.children) {
            this.updateContent();
            this.openWindow();
        }
    }

    onOpen() {
        if (this.props.onOpen) {
            this.props.onOpen(this.infowindow);
        }
    }

    onClose() {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    openWindow() {
        this.infowindow.open(this.props.map, this.props.marker);
    }

    updatePosition() {
        let pos = this.props.position; // eslint-disable-next-line

        if (!(pos instanceof google.maps.LatLng)) { // eslint-disable-next-line
            pos = pos && new google.maps.LatLng(pos.lat, pos.lng); // eslint-disable-next-line
        }

        this.infowindow.setPosition(pos);
    }

    updateContent() {
        const content = this.renderChildren();

        this.infowindow.setContent(content);
    }

    closeWindow() {
        this.infowindow.close();
    }

    renderChildren() {
        const {
            children,
        } = this.props;
        return ReactDOMServer.renderToString(children);
    }

    render() {
        return null;
    }
}

InfoWindow.propTypes2 = {
    children: propTypes2.element.isRequired,
    map: propTypes2.object,
    marker: propTypes2.object,
    position: propTypes2.object,
    visible: propTypes2.bool,

    // callbacks
    onClose: propTypes2.func,
    onOpen: propTypes2.func,
};

InfoWindow.defaultProps = {
    visible: false,
};

export default InfoWindow;
